
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormValues, formSchema } from "@/types/loan";
import { loadApplicationData } from "./useApplicationSubmit";
import { LoanPurpose } from "@/services/api/types";

export const useLoanFormState = () => {
  const [loanAmount, setLoanAmount] = useState(15000);
  const [loanTerm, setLoanTerm] = useState(5);
  const [loanType, setLoanType] = useState("kulutusluotto");

  // Initialize form with default values and validation
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      loanPurpose: LoanPurpose.Other,
      loanAmount: loanAmount,
      loanTerm: loanTerm,
      termsAccepted: false,
      marketingConsent: false,
      loanType: "kulutusluotto",
      education: "",
      natureOfWork: "",
      startOfEmployment: "",
      hasCoApplicant: false
    }
  });

  // Load saved data on component mount
  useEffect(() => {
    const savedData = loadApplicationData();
    if (savedData) {
      // Update form values with saved data
      Object.entries(savedData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          form.setValue(key as any, value);
        }
      });

      // Update local state for loan amount and term if present in saved data
      if (savedData.loanAmount) {
        setLoanAmount(savedData.loanAmount);
      }
      if (savedData.loanTerm) {
        setLoanTerm(Math.min(savedData.loanTerm, 15));
      }
    }
  }, [form]);

  return {
    form,
    loanAmount,
    setLoanAmount,
    loanTerm,
    setLoanTerm,
    // Do not return setLoanType for Finnish forms
    loanType
  };
};
